import {
  DashboardVariableValuesDTO,
  type DashboardVariableValues,
} from './variable';

export const DASHBOARD_VARIABLES_PARAM = 'vars';

export const parseUrlVariableValues = (
  value: unknown,
): DashboardVariableValues => {
  const parsed = DashboardVariableValuesDTO.safeParse(value);
  if (!parsed.success) return {};
  return Object.fromEntries(
    Object.entries(parsed.data).filter(([name]) =>
      /^[A-Za-z][A-Za-z0-9_]*$/.test(name),
    ),
  );
};

export const appendUrlVariableValues = (
  params: URLSearchParams,
  values: DashboardVariableValues,
) => {
  if (Object.keys(values).length) {
    params.set(DASHBOARD_VARIABLES_PARAM, JSON.stringify(values));
  }
  return params;
};